<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>所属変更</h5>
      </div>
      <div class="col-3">
        <button id="backBtn" type="button" class="btn-sm btn-outline-info" v-on:click="back">中断する</button>
      </div>
    </div>
    <div id="register_form" class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <form @submit.prevent="modify">
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>ID</label>
              </div>
              <div class="col-9">
                <input type="text" v-model="user.userCode" class="form-control" disabled>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>名称</label>
              </div>
              <div class="col-9">
                <input type="text" v-model="user.userName" class="form-control" disabled>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>所属（組織）</label>
              </div>
              <div class="col-9">
                <select class="form-control" v-model="belong.organizationId" required>
                  <option v-for="option in organizationOptions" v-bind:value="option.id" v-bind:key="option.id">
                    {{ option.displayName }}
                  </option>
                </select>
              </div>
            </div>  
          </div>
          <button id="modify_button" type="submit" class="btn btn-info btn btn-block">{{btnLabel}}</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Modify',
  mixins: [sessions,path,headers],
  props: ['realms'],
  data: function(){
    return {
      historyId: 0,
      reserveId: 0,
      belongId: 0,
      message: '',
      organizationOptions: [],
      next: true,
      nextUserId: '',
      nextBelongId: '',
      user: {
        userCode: '',
        userName: ''
      },
      belong: {
        userId: '',
        organizationId: '',
        reserveId: 0,
      }
    }
  },
  computed: {
    isMessage: function () {
      return this.message.length > 0
    },
    btnLabel: function () {
      return this.next === true ? '次へ' : '終了する'
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          this.belongId = this.$route.params.id;
          this.reserveId = this.$route.params.reserveid
          this.historyId = this.$route.params.historyid;
          axios.get("/api/belong/" + this.belongId, {
              headers: this.headers(accessToken)
          }).then(response => {
            this.user = {
              userCode: response.data.data.belong.user.userCode,
              userName: response.data.data.belong.user.userName,
            }
            this.belong = {
              userId: response.data.data.belong.userId,
              organizationId: response.data.data.belong.organizationId,
              reserveId: response.data.data.belong.reserveId,
            }
            this.getOrganization()
            this.getNextUser()
          }).catch(err => {
            this.message = err.message
          })
        }
      }).catch((err) => {
        this.message = err.message
      })
    },
    modify() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          axios.put("/api/belong/" + this.belongId, {
              belong: this.belong
          },{
            headers: this.headers(accessToken)
          }).then(response => {
            var res = response.data;
            if(res.errorMessage) {
              this.message = res.errorMessage
            } else {
              // alert('更新されました。');
              this.toNextPage()
            }
          }).catch(err => {
            this.message = err.message
          })
        }
      }).catch((err) => {
        this.message = err.message
      })
    },
    back() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/reserve/belonglist/'+this.historyId+'/'+this.reserveId))
    },
    getOrganization() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var hospitalId = this.$store.getters.hospital.id
          axios.post("/api/organization/management/belonglist", {
            hospitalId: hospitalId,
            historyId: this.historyId
          },
          {
            headers: this.headers(accessToken)
          }).then(response => {
            this.organizationOptions = response.data.data.organizations
            if(this.organizationOptions.length > 0) {
              var selected = this.organizationOptions[0]
              this.user.organizationId = selected.id
            }
          }).catch(err => {
            throw err
          })
      } else {
        //this.$router.replace('/login') 
      }}).catch((err) => {
        this.message = err.message
      })
    },
    getNextUser() {
      this.$cognito.isAuthenticated().then((session) => {
      if(session){
        var accessToken = this.getAccessToken(this.$cognito,session)
        var hospitalId = this.$store.getters.hospital.id
        axios.get("/api/belong/next/" + hospitalId +'/'+ this.belong.userId +'/'+ this.reserveId, {
            headers: this.headers(accessToken)
        }).then(response => {
          this.next = response.data.data.next
          this.nextUserId = response.data.data.nextUserId
          this.nextBelongId = response.data.data.nextBelongId
        }).catch(err => {
          this.message = err.message
        })
      }}).catch((err) => {
          this.message = err.message
      })
    },
    toNextPage() {
      if(this.next) {
        if(this.nextBelongId !== 0) {
          this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/reserve/belongmodify/'+this.historyId+'/'+this.reserveId+'/'+this.nextBelongId))
          this.init()
        } else {
          this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/reserve/belongcreate/'+this.historyId+'/'+this.reserveId+'/'+this.nextUserId))
        }
      } else {
        this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/reserve/index'))
      }
    }
  }
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#backBtn {
  float:right;
}
#modify_button {
  margin-top: 30px;
}
.radio_label {
  margin-left: 0.5rem;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>